import React from "react";
import {
  Container,
  Paper,
  Title,
  Text,
  Button,
  Stack,
  Timeline,
  Transition,
} from "@mantine/core";
import { IconBarrierBlock, IconFilePencil } from "@tabler/icons-react";

function PlaceholderPage({ title }) {
  return (
    <Container size="md">
      <Timeline active={0} lineWidth={3} bulletSize={32}>
        <Timeline.Item
          color="var(--primary-color)"
          bullet={<IconFilePencil size={18} />}
        >
          <Transition
            mounted={true}
            transition="scale"
            duration={250}
            timingFunction="ease"
          >
            {(styles) => (
              <Paper
                shadow="xs"
                p="xl"
                withBorder
                mb="md"
                style={{ ...styles, overflow: "hidden" }}
              >
                <Stack align="center" spacing="md">
                  <Title order={3} ta="center">
                    {title}
                  </Title>
                  <IconBarrierBlock size={48} stroke={1.5} color="#364379" />
                  <Text size="md" ta="center">
                    We're working hard to bring you this feature soon!
                  </Text>
                </Stack>
              </Paper>
            )}
          </Transition>
        </Timeline.Item>
      </Timeline>
    </Container>
  );
}

export default PlaceholderPage;
